import React from 'react'

import { Divider, ListItem, ListItemText, ListItemIcon } from '@material-ui/core'

const MenuListItem = React.forwardRef(({ menu, clicked, translate }, ref) => {
  const { label, path, icon, isDivider } = menu

  let onClick = null
  let labelDisplay = null
  let readOnly = !path

  if (isDivider) {
    return <Divider />
  }

  if (label) {
    try {
      labelDisplay = translate(label) || label
    } catch (error) {
      labelDisplay = label
    }
  }

  if (path) {
    onClick = () => clicked(path)
  }

  return (
    <ListItem innerRef={ref} button={!readOnly} onClick={onClick}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText primary={labelDisplay} />
    </ListItem>
  )
})

export default MenuListItem
